// extracted by mini-css-extract-plugin
export default {"metrics":"RouteModule_metrics__BwAu1","metric":"RouteModule_metric__gaLIQ","title":"RouteModule_title__Pxin9","data":"RouteModule_data__DPwOx"};